import { defineStore } from 'pinia'

const useChannelStore = defineStore('channel', {
  state: () => {
    return {
      arrowPopupVisible: false,
      qrcodePopupVisible: false,
      qaQrcodePopupVisible: false,
      consultationPopupVisible: false,
      adPopupVisible: false,
    }
  },
  actions: {
    showArrowPopup() {
      this.arrowPopupVisible = true
    },
    hideArrowPopup() {
      this.arrowPopupVisible = false
    },
    showQrcodePopup() {
      this.qrcodePopupVisible = true
    },
    hideQrcodePopup() {
      this.qrcodePopupVisible = false
    },
    showQaQrcodePopup() {
      this.qaQrcodePopupVisible = true
    },
    hideQaQrcodePopup() {
      this.qaQrcodePopupVisible = false
    },
    showConsultationPopup() {
      this.consultationPopupVisible = true
    },
    hideConsultationPopup() {
      this.consultationPopupVisible = false
    },
    showAdPopup() {
      this.adPopupVisible = true
    },
    hideAdPopup() {
      this.adPopupVisible = false
    },
  },
})

export default useChannelStore
